enum ScenarioElementType {
  description = 'description',
  target = 'target',
  constraints = 'constraints',
  behavior = 'behavior',
}

export const scenarioElementTypeAsString = (
  scenarioElementType: ScenarioElementType
): string => {
  switch (scenarioElementType) {
    case ScenarioElementType.description:
      return 'Description';
    case ScenarioElementType.target:
      return 'But à atteindre';
    case ScenarioElementType.constraints:
      return 'Contraintes';
    case ScenarioElementType.behavior:
      return 'Comportement';
  }
};

export const scenarioElementTypeAsEnum = (
  scenarioElementType: string
): ScenarioElementType => {
  switch (scenarioElementType) {
    case 'description':
      return ScenarioElementType.description;
    case 'target':
      return ScenarioElementType.target;
    case 'constraints':
      return ScenarioElementType.constraints;
    case 'behavior':
      return ScenarioElementType.behavior;
    default:
      return ScenarioElementType.description;
  }
};

export default ScenarioElementType;
